import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-100 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 py-8">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 mb-6">
          {/* Brand Section */}
          <div className="text-center md:text-left">
            <h3 className="text-lg font-bold text-gray-800 mb-2">Vans Shoes Coupon Club</h3>
            <p className="text-gray-600 text-sm">
              Your one-stop destination for the best deals, coupons, and cashback offers from top retailers.
            </p>
          </div>

          {/* Quick Links */}
          <div className="text-center">
            <h4 className="font-semibold text-gray-800 mb-3">Quick Links</h4>
            <div className="flex flex-wrap justify-center gap-x-4 gap-y-2">
              <Link to="/" className="text-gray-600 text-sm hover:text-gray-800 transition-colors">
                Home
              </Link>
              <Link to="/stores" className="text-gray-600 text-sm hover:text-gray-800 transition-colors">
                All Stores
              </Link>
              <Link to="/blog" className="text-gray-600 text-sm hover:text-gray-800 transition-colors">
                Blog
              </Link>
              <Link to="/contact" className="text-gray-600 text-sm hover:text-gray-800 transition-colors">
                Contact
              </Link>
              <Link to="/privacy-policy" className="text-gray-600 text-sm hover:text-gray-800 transition-colors">
                Privacy Policy
              </Link>
            </div>
          </div>

          {/* Contact */}
          <div className="text-center md:text-right">
            <h4 className="font-semibold text-gray-800 mb-3">Contact Us</h4>
            <a 
              href="mailto:ea209732@gmail.com" 
              className="text-gray-600 text-sm hover:text-gray-800 transition-colors"
            >
              ea209732@gmail.com
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-200 pt-6">
          <p className="text-gray-500 text-sm text-center">
            © 2025 Vans Shoes Coupon Club. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
